import { inject, Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgressBarService {
  private zone = inject(NgZone);

  protected readonly progressBarSubject = new BehaviorSubject<boolean>(false);
  protected readonly loadingMap: Map<string, boolean> = new Map<
    string,
    boolean
  >();

  public getProgressBar$() {
    return this.progressBarSubject.asObservable().pipe(shareReplay(1));
  }

  public setLoading(loading: boolean, url: string): void {
    if (!url) {
      throw new Error(
        'The request URL must be provided to the ProgressBarService.setLoading function'
      );
    }

    this.zone.run(() => {
      if (loading === true) {
        this.loadingMap.set(url, loading);
        this.progressBarSubject.next(true);
      } else if (loading === false && this.loadingMap.has(url)) {
        this.loadingMap.delete(url);
      }
      if (this.loadingMap.size === 0) {
        this.progressBarSubject.next(false);
      }
    });
  }
}
